export const TASK_KEYS = {
    all: ['TASKS'],
    filter: (filters: Record<string, unknown>) => [...TASK_KEYS.all, FILTERED_KEY, filters] as const,
    single: (taskId: string) => [...TASK_KEYS.all, taskId] as const,
}

export const FILTERED_KEY = 'FILTERED'
